import gql from 'graphql-tag';

export default gql`
mutation updateProjectPlugin(
  $projectId: Int,
  $handle: String!,
  $settings: jsonb!,
  $isActive: Boolean!
) {
  update_plugins(
    where: {
      _and: {
        project_id: {_eq: $projectId},
        handle: {_eq: $handle}
      }
    }, 
    _set: {
      settings: $settings, 
      enabled: $isActive
    }
  ) {
    affected_rows
  }
}
`;
